import React, { useState } from 'react';

const PinPad = ({ onComplete, onCancel, length = 4 }) => { 
    // ⚠️ CAPTAIN'S NOTE: If your Odoo PINs are 6 digits, 
    // go to PortalGate.js and change it to: <PinPad length={6} ... />

    const [pin, setPin] = useState('');

    const handleNumberClick = (num) => {
        if (pin.length < length) {
            const newPin = pin + num;
            setPin(newPin);
            
            // Auto-submit when length is reached
            if (newPin.length === length) {
                setTimeout(() => {
                    onComplete(newPin); // Send to backend
                    setPin('');         // 🧹 MAGIC FIX: Instantly clear the pad so they can try again!
                }, 150); // Slight delay so the user sees the final dot fill in
            }
        }
    };

    const handleDelete = () => {
        if (pin.length > 0) {
            setPin(pin.slice(0, -1));
        }
    };

    return (
        <div style={styles.container}>
            {/* The Dots Display */}
            <div style={styles.display}>
                {[...Array(length)].map((_, i) => (
                    <div key={i} style={{
                        ...styles.dot,
                        backgroundColor: pin.length > i ? '#2196F3' : '#e0e0e0',
                        transform: pin.length > i ? 'scale(1.1)' : 'scale(1)'
                    }} />
                ))}
            </div>

            {/* The Numpad */}
            <div style={styles.grid}>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(num => (
                    <button key={num} onClick={() => handleNumberClick(num)} style={styles.btn}>
                        {num}
                    </button>
                ))}
                
                <button onClick={onCancel} style={{ ...styles.actionBtn, color: '#d32f2f' }}>
                    ยกเลิก
                </button>
                
                <button onClick={() => handleNumberClick(0)} style={styles.btn}>
                    0
                </button>
                
                <button onClick={handleDelete} style={{ ...styles.actionBtn, color: '#f57c00' }}>
                    ลบ
                </button>
            </div>
        </div>
    );
};

const styles = {
    container: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '30px' },
    display: { display: 'flex', gap: '15px', marginBottom: '10px', height: '24px', alignItems: 'center' },
    dot: { width: '20px', height: '20px', borderRadius: '50%', transition: 'all 0.15s ease-in-out' },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(3, 85px)', gap: '15px' },
    btn: {
        width: '85px', height: '85px', borderRadius: '50%', border: '1px solid #e0e0e0',
        background: '#fff', fontSize: '28px', fontWeight: '500', color: '#333', cursor: 'pointer',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        boxShadow: '0 2px 5px rgba(0,0,0,0.05)', transition: 'background 0.2s'
    },
    actionBtn: {
        width: '85px', height: '85px', borderRadius: '50%', border: 'none',
        background: 'transparent', fontSize: '18px', fontWeight: 'bold', cursor: 'pointer',
        display: 'flex', alignItems: 'center', justifyContent: 'center'
    }
};

export default PinPad;